﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
//import * as mathjs from 'mathjs';

import tpl_cart from './tpl/cart.html';
import config from '../../../common/config';
import language from '../../../common/language';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_Pagination from '../../../lib/views/pagination/pagination';
import View_CartList from './CartList';
var template = require('../../js/template');

import View_CartListItem from './cartListItem';

export default Marionette.CompositeView.extend({
    //childViewContainer: '#cartList',
    childViewContainer: '#cartList',
    childView: View_CartListItem,
    getTemplate: function () {
        return tpl_cart({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        this.model = new Entities_Empty.Model();

        this.model.attributes.SubTotal = 0;
        this.model.attributes.SubTotalNoVat = 0;
        this.model.attributes.SubTotalVat = 0;
        this.model.attributes.Total = 0;
        this.model.attributes.Currency = language.getCurrencyFromCultureName(config.cultureName());
        
        this.listenTo(this.collection, 'change', this.render);
        this.listenTo(this.model, 'change', this.render);
    },
    //regions: {
    //    cartList: "#cartList"
    //},
    onBeforeShow: function () {
        var self = this;

        //this.cartList.show(new View_CartList({ collection: this.collection, app : this.app }));
        var userChannel = Backbone.Radio.channel('app');

        this.listenTo(userChannel, 'cart:deleteItem', function(model) {
            self.collection.remove(model);

            var userChannel = Backbone.Radio.channel('app');
            userChannel.trigger('menu:shopRefreshCart');
            userChannel.trigger('cart:recalculate');
        });

        this.listenTo(userChannel, 'cart:recalculate', function() {
            self.recalculate();
        });
    },
    ui : {
        'cart_btnShop' : '#cart_btnShop',
        'cart_btnOrder' : '#cart_btnOrder',
        'cart_subTotal' : '#cart_subTotal',
        'cart_subTotalNoVat' : '#cart_subTotalNoVat'
    },
    events: {
        'click @ui.cart_btnShop': 'btnShop',
        'click @ui.cart_btnOrder': 'btnOrder'
    },
    onRender: function () {
        if (this.model.attributes.SubTotalNoVat > 0) {
            this.ui.cart_subTotalNoVat.show();
            this.ui.cart_subTotal.text(resources.X100873);
        } else {
            this.ui.cart_subTotalNoVat.css('display', 'none');
            this.ui.cart_subTotal.text(resources.X100852);
        }
    },
    onAttach(){
        //template.render();
        this.recalculate();
    },
    btnShop: function (event) {
        event.preventDefault();

        window.app.router.navigate("#shop");
        window.app.router.shop();  
    },
    btnOrder: function (event) {
        event.preventDefault();

        window.app.router.navigate("#order");
        window.app.router.order();  
    },
    item_btnVatClick: function (event) {
        event.preventDefault();

        this.recalculate();
    },
    round : function (x, currency) {
        switch (currency) {
            case 'DKK' : return Math.floor(x); break;//return this.round25(x); break;
            default : return x;
        }
    },
    round25 : function (x)
    {
        var number = (x < 0) ? Math.ceil(x) : Math.floor(x);
        //var fraction = Math.trunc((x - Math.trunc(x)) * 100);
        //var fraction = Math.abs((x - Math.abs(x)) * 100);

        //var fraction = Math.trunc(x * 100) - (number * 100);
        var fraction = Math.floor(x * 100) - (number * 100);
        

        var da_DK_fraction = 0;

        if (fraction >= 0 && fraction <= 24) da_DK_fraction = 0;
        else if (fraction >= 25 && fraction <= 74) da_DK_fraction = 0.5
        else if (fraction >= 75) da_DK_fraction = 1;

        var total = number + da_DK_fraction;

        return total;
    },
    recalculate : function () {
        var self = this;

        this.model.attributes.SubTotal = 0;
        this.model.attributes.SubTotalNoVat = 0;
        this.model.attributes.SubTotalVat = 0;
        this.model.attributes.Total = 0;
        this.model.attributes.Currency = language.getCurrencyFromCultureName(config.cultureName());

        //Remove All freight
        var freightCollection = this.collection.where( {ConfigShopFreight : -2} );
        for (var i = 0; i < freightCollection.length; i++){
            freightCollection[i].destroy({ 
                wait: true
            });
        }

        //Insert All Freight
        this.collection.forEach(function (entry) {
            if (entry.attributes.ConfigShopFreight != -1) {
                var configShopFreight = self.app.entities.collections.publicConfigShopFreight.where( {id :entry.attributes.ConfigShopFreight } ); 
                if (configShopFreight.length > 0) {
                    
                    var model = configShopFreight[0];
                    var price = entry.attributes.Qty * configShopFreight[0].attributes.Price;

                    var foundModel = self.app.entities.collections.publicShopCart.where({tmpId : model.attributes.id, ConfigShopFreight : -2});
                    if (foundModel.length > 0) {
                        foundModel[0].attributes.Price += price;
                    } else {
                        self.app.entities.collections.publicShopCart.create({ 
                            ConfigShopFreight : -2,
                            Image01 : '',
                            tmpId : model.attributes.id, 
                            ShopOrder : model.attributes.ShopOrder,
                            Qty : 1,
                            CultureName : model.attributes.CultureName,
                            Currency : model.attributes.Currency,
                            ItemId : model.attributes.ItemId,
                            Name : model.attributes.Name,
                            InvoiceDescriptionText  : model.attributes.InvoiceDescriptionText,
                            InvoiceCommentsText : model.attributes.InvoiceCommentsText,
                            AccountNumber : model.attributes.AccountNumber,
                            Price : price,
                            Vat : model.attributes.Vat,
                        });
                    }
                }
            }
        });

        this.collection.forEach(function (entry) {
            if (entry.attributes.Vat == 1) {
                self.model.attributes.SubTotalNoVat +=  entry.attributes.Qty * entry.attributes.Price;
            } else {
                self.model.attributes.SubTotal +=  entry.attributes.Qty * entry.attributes.Price;
                self.model.attributes.SubTotalVat += entry.attributes.Qty * ((entry.attributes.Vat * entry.attributes.Price) - entry.attributes.Price);
            }
        });

        self.model.attributes.Total =  self.model.attributes.SubTotal + self.model.attributes.SubTotalNoVat + self.model.attributes.SubTotalVat;

        this.model.trigger('change');
        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('menu:shopRefreshCart');
    }
}, Backbone.Radio.Requests);